import EstateDetailsCard from '@/components/estate/EstateDetailsCard';
import EstateGrowerCard from '@/components/estate/EstateGrowerCard';
import EstateVarietalCard from '@/components/estate/EstateVarietalCard';

import { Button } from '@/components/shadcn-ui/button';
import { addEstate, getEstates } from '@/network/api.service';
import createEstateSchema from '@/schema/estate-schema';
import { useEstateStore } from '@/stores/useEstate.store';
import { useUserStore } from '@/stores/useUser.store';
import { yupResolver } from '@hookform/resolvers/yup';
import { Loader2 } from 'lucide-react';
import React, { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

const CreateEstatePage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const user = useUserStore(state => state.user);
  const setEstates = useEstateStore(state => state.setEstates);

  const form = useForm({
    resolver: yupResolver(createEstateSchema),
    defaultValues: {
      name: '',
      location: { location_pin: '' },
      size_in_acres: '',
      altitude: '',
      estate_code: '',
      growers: [{ name: '', phone_number: '' }],
      managers: [{ name: '', phone_number: '' }],
      varietal_details: [{ varietal: '', area_in_acres: null }],
    },
  });

  const { handleSubmit, reset } = form;

  const onSubmit = async data => {
    setLoading(true);
    try {
      const { data: respData, message } = await addEstate({ ...data, created_by: user.user_id });

      if (respData?.success) {
        // Will shift it universaly
        const { data } = await getEstates();
        setEstates(data?.data);
        toast.success('Estate created successfully.');
        reset();
        navigate('/estates', { replace: true });
      }
    } catch (error) {
      toast.error(error.response?.data?.message);
      // toast.error('Failed to created Estate');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-[18px] px-4 py-[18px]">
      <FormProvider {...form}>
        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col space-y-[18px]">
          <EstateDetailsCard loading={loading} />
          <EstateGrowerCard loading={loading} />
          <EstateVarietalCard loading={loading} />

          <Button type="submit" disabled={loading}>
            {loading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Saving...
              </>
            ) : (
              'Save Estate'
            )}
          </Button>
        </form>
      </FormProvider>
    </div>
  );
};

export default CreateEstatePage;
